import axios from '@/api/config/index';

const baseUrl = process.env.NODE_ENV === 'development' ? '/tc-server' : 'https://peiqisport.club';
// const baseUrl = process.env.NODE_ENV === 'development' ? '/tc-server' : 'http://118.196.116.202:3001';

export function createDict (data: any) {
  return axios({
    url: `${baseUrl}/data-use/dict/create`,
    method: 'post',
    data
  })
}
export function getDictList (data: any) {
  return axios({
    url: `${baseUrl}/data-use/dict/list`,
    method: 'post',
    data
  })
}
export function getDictDetail (data: any) {
  return axios({
    url: `${baseUrl}/data-use/dict/detail`,
    method: 'post',
    data
  })
}
export function updateDict (data: any) {
  return axios({
    url: `${baseUrl}/data-use/dict/update`,
    method: 'post',
    data
  })
}
export function deleteDict (data: any) {
  return axios({
    url: `${baseUrl}/data-use/dict/delete`,
    method: 'post',
    data
  })
}
export function getDictByType (data: any, options: { silentError?: boolean } = {}) {
  return axios({
    url: `${baseUrl}/data-use/dict/get-by-type`,
    method: 'post',
    data,
    ...options
  })
}
export function getDistinctTypes () {
  return axios({
    url: `${baseUrl}/data-use/dict/distinct-types`,
    method: 'get'
  })
}


export function getDictByTypes(data: { types: string[] }) {
  return axios({
    url: `${baseUrl}/data-use/dict/batch`,
    method: 'post',
    data
  })
}
